import SvgColor from "../../components/svg-color/svg-color";
import { useAppSelector } from "../../app/hooks";

// ----------------------------------------------------------------------

const icon = (name: string) => (
  <SvgColor
    src={`/assets/icons/navbar/${name}.svg`}
    sx={{ width: 1, height: 1 }}
  />
  // OR
  // <Iconify icon="fluent:mail-24-filled" />
  // https://icon-sets.iconify.design/solar/
  // https://www.streamlinehq.com/icons
);

const ICONS = {
  job: icon("ic_job"),
  blog: icon("ic_blog"),
  chat: icon("ic_chat"),
  mail: icon("ic_mail"),
  user: icon("ic_user"),
  file: icon("ic_file"),
  lock: icon("ic_lock"),
  tour: icon("ic_tour"),
  order: icon("ic_order"),
  label: icon("ic_label"),
  blank: icon("ic_blank"),
  kanban: icon("ic_kanban"),
  folder: icon("ic_folder"),
  banking: icon("ic_banking"),
  booking: icon("ic_booking"),
  invoice: icon("ic_invoice"),
  product: icon("ic_product"),
  calendar: icon("ic_calendar"),
  external: icon("ic_external"),
  menuItem: icon("ic_menu_item"),
  ecommerce: icon("ic_ecommerce"),
  analytics: icon("ic_analytics"),
  dashboard: icon("ic_dashboard"),
};

// ----------------------------------------------------------------------

// Surgery modülü için path belirleyen yardımcı fonksiyon
const getSurgeryPath = (description: string) => {
  switch (description) {
    case "Ameliyat Raporlama":
      return "/surgery/surgery-reporting";
    case "Konsey İşlemleri":
      return "/surgery/council-procedures";
  }
};

export function useNavData() {
  const userMenus = useAppSelector(
    (state) => state.userMenus.data
  );

  //MODULE_NAME distinct
  const modules = userMenus
    ?.map((item: any) => item.module_name)
    .filter(
      (value: any, index: any, self: any) => self.indexOf(value) === index
    );

  // I have just Modules Header and all the items under it
  let newData: any = [
    {
      subheader: "",
    },
  ];

  const iconsArray = Object.values(ICONS);

  newData[0].items = modules?.map((module: string, index: number) => {
    return {
      title: module,
      icon: iconsArray[index % iconsArray.length], // Assign icons in order and repeat if necessary
      path: "#/",
      children: userMenus
        ?.filter((item: any) => item.module_name === module)
        ?.map((item: any) => {
          return {
            title: item.descriptions ?? "Başlık Yok",
            path: item.web_url || (item.module_name === "AMELİYATHANE" ? getSurgeryPath(item.descriptions) : "#"),
          };
        }),
    };
  });

  return newData;
}
